import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b806c3c")

_pushScopeId("data-v-0b806c3c")
const _hoisted_1 = { style: {"padding-top":"200px","text-align":"center"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { style: {"padding-top":"20px"} }, [
  /*#__PURE__*/_createVNode("label", { class: "label" }, "Invalid page."),
  /*#__PURE__*/_createVNode("a", {
    class: "label",
    href: "/manage-new/#/login"
  }, "Please login again.")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      src: require('@/assets/image/404.png')
    }, null, 8, ["src"]),
    _hoisted_2
  ]))
})